module.exports = __webpack_public_path__ + "img/imagen-no-disponible.d5ee224d.gif";